import us from '../../defines';

export class NavigationService {
  constructor (uScope, viewport, annotationsService) {
    viewport.events.on('viewport:change-navigation', navMode => {
      if (!uScope.canAnnotate()) {
        return;
      }

      let handled = false;

      switch (navMode) {
        case us.eNavModes.nmAnnotPin:
        case us.eNavModes.nmAnnotArrow:
        case us.eNavModes.nmAnnotText:
        case us.eNavModes.nmAnnotReport:
        case us.eNavModes.nmAnnotRect:
        case us.eNavModes.nmAnnotEllipse:
        case us.eNavModes.nmAnnotPen:
        case us.eNavModes.nmAnnotNegPen:
        case us.eNavModes.nmAnnotCaliper:
        case us.eNavModes.nmAnnotPolygon:
        case us.eNavModes.nmRedrawStarting:
        case us.eNavModes.nmRedraw:
          handled = true;
          viewport.setCursor('pointer');
          break;
      }

      return handled;
    });

    viewport.events.on('viewport:stop-navigation', navMode => {
      let handled = false;

      switch (navMode) {
        case us.eNavModes.nmAnnotPin:
        case us.eNavModes.nmAnnotArrow:
        case us.eNavModes.nmAnnotReport:
        case us.eNavModes.nmAnnotText:
        case us.eNavModes.nmAnnotRect:
        case us.eNavModes.nmAnnotEllipse:
        case us.eNavModes.nmAnnotPen:
        case us.eNavModes.nmAnnotNegPen:
        case us.eNavModes.nmAnnotCaliper:
        case us.eNavModes.nmAnnotPolygon:
        case us.eNavModes.nmRedrawStarting:
        case us.eNavModes.nmRedraw:
          handled = true;
          viewport.setCursor('auto');
          annotationsService.drawingCompleted();
          break;
        default:
      }

      return handled;
    });
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/navigation-service.js